module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zh-CN":{"order":{"product_options":"已选：{0}"}}}')
  delete Component.options._Ctor
}
